import { useMemo, useState } from 'react';
import { every } from 'lodash';
import { TariffKindInternal } from '../../../../../../../data-access/gql-types/graphql';
import { useDevicesAndChannelsContext } from '../../../../../context/devices-and-channels';
import { useGetTariffs } from '../../../../../hooks/tariffs/use-get-tariffs';
import { ChannelMeterTypeOrUndefined } from '../../../../../types';
import { tariffKind } from '../../../optimizer/configuration/utils/tariff-kind';
import { TariffPricesData } from '../types';

export const useMeterPrices = (selectedPhases?: number[]) => {
  const { channel } = useDevicesAndChannelsContext();
  const kind = (channel?.data as ChannelMeterTypeOrUndefined)?.tariff?.kind;
  const [emptyPrices, setEmptyPrices] = useState<boolean>(false);
  const { allTariffs } = useGetTariffs();

  const tariffPricesConfiguration = useMemo(() => {
    const tariffConfigurations =
      (channel?.data as ChannelMeterTypeOrUndefined)?.sharedChannelSettings?.tariffConfigurations || [];
    const priceData = tariffConfigurations.find((x) => x.tariff === kind);

    if (!kind || kind === TariffKindInternal.None) return null;

    if (!kind.includes('_DYNAMIC') && kind !== TariffKindInternal.TauronG13S) {
      if (!priceData) {
        setEmptyPrices(true);
        return null;
      }

      const myTariff = tariffKind[kind];

      const operatorTariff = allTariffs.find((x) => x.operator.toLowerCase() === myTariff.operator);

      if (operatorTariff) {
        if (kind === priceData.tariff) {
          if (!priceData.prices.length || every(priceData.prices, (x) => !x.price)) setEmptyPrices(true);
          else setEmptyPrices(false);

          return {
            prices: priceData.prices.reduce((result, tier) => {
              result[tier.pricingTier] = tier.price;
              return result;
            }, {}),
            hours: operatorTariff.tariffs.find((x) => x.name.toLowerCase() === myTariff.tariff)?.hoursRanges || [],
          } as TariffPricesData;
        } else {
          setEmptyPrices(true);
        }
      }
    }

    return null;
  }, [channel?.data, kind, allTariffs, selectedPhases?.length]);

  return {
    tariffPricesConfiguration,
    emptyPrices,
  };
};
